import { Box, ButtonBase, Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { Colors } from '../../../../themes';

const ManualCategoryCard: React.FC<{
  actionLabel?: string;
  icon: React.ReactNode;
  title: string;
  previewItems: string[];
  opensMenu?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  contentSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}> = ({ actionLabel, icon, title, previewItems, onClick, contentSx, sx }) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={[
        {
          'alignItems': 'stretch',
          'border': `1px solid ${Colors.primaryLightest}`,
          'borderRadius': '8px',
          'display': 'flex',
          'height': '100%',
          'justifyContent': 'flex-start',
          'p': '20px 20px 10px 20px',
          'textAlign': 'left',
          'width': '100%',
          '&:hover': {
            backgroundColor: Colors.disabledLight,
            borderColor: Colors.primaryLightest,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}>
      <Stack
        spacing={'10px'}
        width='100%'
        sx={[...(Array.isArray(contentSx) ? contentSx : [contentSx])]}>
        <Stack alignItems='center' direction='row' justifyContent='space-between' spacing={1}>
          <Box
            sx={{
              alignItems: 'center',
              color: Colors.primaryBase,
              display: 'flex',
              minHeight: 26,
            }}>
            {icon}
          </Box>
          {actionLabel ? (
            <Typography color='primary' variant='p16Bold'>
              {actionLabel}
            </Typography>
          ) : null}
        </Stack>
        <Box sx={{ minWidth: 0 }}>
          <Stack alignItems='center' direction='row' justifyContent='space-between' spacing={1}>
            <Typography color='primary' sx={{ minWidth: 0 }} variant='p12'>
              {title}
            </Typography>
          </Stack>
          <Typography
            component='div'
            color='secondary'
            sx={{ mt: 0.5, pr: 1, wordBreak: 'break-word' }}
            variant='p16SemiBold'>
            {previewItems.map((item, index) => (
              <React.Fragment key={`${title}-${item}`}>
                {index > 0 ? (
                  <Box component='span' sx={{ display: 'inline-block', mx: '10px' }}>
                    |
                  </Box>
                ) : null}
                <Box component='span'>{item}</Box>
              </React.Fragment>
            ))}
          </Typography>
        </Box>
      </Stack>
    </ButtonBase>
  );
};

export default ManualCategoryCard;
